import { ShareContent } from './ShareContent';
import { ButtonV2 } from '../../ButtonV2/ButtonV2';
import styles from './ShareDialog.module.scss';
import { icons } from '../../../assets';
import GroupImage from '../../../assets/images/configurator/group.png';
import { useEffect, useState } from 'react';
import { CreateLink } from './CreateLink';
import { useCopyToClipboard } from 'react-use';
import { getUrlOrIframeUrlWithToken } from '../utils';
import { successToastV2 } from '../../../helpers/toastHelper';
import Switch from '../../admin/switch';
import Loader from '../../Loader/Loader';
import { updateAllSceneToken } from '../../../api/configuratorApi';

const { IFrameIcon, LinkIcon } = icons;

export const TabShareEmbed = ({ title, customData, getCustomLinks, scenes, data, description }) => {
  const [showCreateLink, setShowCreateLink] = useState(false);
  const [selected, setSelected] = useState(null);
  const [state, copy] = useCopyToClipboard();
  const [loader, setLoader] = useState(false);
  const [customLinks, setCustomLinks] = useState([]);
  const v2 = data?.version_type === 'V2';

  useEffect(() => {
    setCustomLinks(customData);
  }, [customData]);

  const onClose = () => {
    setShowCreateLink(false);
    setSelected(null);
  };

  const changeToggleValueGroup = async (group) => {
    setLoader(true);
    const result = await updateAllSceneToken({
      data: { is_active: !group?.is_active },
      id: data?.id,
      token: group?.unique_id,
      sceneLinkType: 'COMBINATION',
      v2,
    });
    if (result?.status) {
      const links = [...customLinks];
      links?.map((val) => {
        if (group.id === val.id) {
          val.is_active = !group?.is_active;
        }
        return val;
      });
      setCustomLinks(links);
      successToastV2(`Custom link ${group?.is_active ? 'enabled' : 'disabled'} successfully`);
    }
    setLoader(false);
  };

  const onClickItem = (group) => {
    setShowCreateLink(true);
    setSelected(group);
  };

  const groupListItem = (group) => {
    return (
      <div
        className={`w-100 d-flex ${styles.sceneListItem} pointer`}
        key={group.id}
        onClick={() => onClickItem(group)}>
        <div
          className={`${styles.groupTitle} pe-2 d-flex justify-content-start align-items-center`}>
          <span className={`${styles.listItemTitle} ellipsis`} title={group.name}>
            {group.name}
          </span>
        </div>
        <div
          className={`${styles.sceneIconContainer} d-flex justify-content-end align-items-center`}>
          {group?.is_active && (
            <>
              <ButtonV2
                className={styles.transparentBtn}
                onClick={(event) => {
                  event?.stopPropagation();
                  const link = getUrlOrIframeUrlWithToken({ token: group?.unique_id });
                  copy(link);
                  successToastV2('Link copied');
                }}>
                <LinkIcon />
              </ButtonV2>
              <ButtonV2
                className={`mx-3 ${styles.transparentBtn}`}
                onClick={(event) => {
                  event?.stopPropagation();
                  const link = getUrlOrIframeUrlWithToken({
                    token: group?.unique_id,
                    isIframe: true,
                  });
                  copy(link);
                  successToastV2('Iframe copied');
                }}>
                <IFrameIcon />
              </ButtonV2>
            </>
          )}
          <div
            className="h-100  d-flex justify-content-start align-items-center"
            onClick={(event) => {
              event?.stopPropagation();
            }}>
            <Switch
              checked={group?.is_active}
              onToggle={() => changeToggleValueGroup(group)}
              toggleId={'1'}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-100 h-100 position-relative">
      <div className={styles.innerContainer}>
        <div className="w-100 mt-3 d-flex justify-content-between">
          <div>
            <ShareContent title={title} description={description}></ShareContent>
          </div>
          <ButtonV2
            color="dark"
            size="sm"
            className="ms-2"
            onClick={() => {
              setShowCreateLink(true);
            }}>
            Create link
          </ButtonV2>
        </div>
        <div className={`w-100 ${styles.createLinkParent}`}>
          {!customLinks.length ? (
            <div className="w-100 h-100 d-flex justify-content-center align-items-center">
              <img src={GroupImage} height="350px" />
            </div>
          ) : (
            <div className={`w-100 h-100`}>
              <div className="w-100 d-flex justify-content-start align-items-center">
                <h6 className={styles.title}>All custom configurators</h6>
              </div>
              <div className={`w-100 ${styles.allScenesContainer} ${styles.overflowScrollHide}`}>
                {customLinks.map((group) => groupListItem(group))}
              </div>
            </div>
          )}
        </div>
      </div>
      {showCreateLink && (
        <CreateLink
          onClose={onClose}
          groupData={selected}
          customLinks={customLinks}
          getCustomLinks={getCustomLinks}
          scenes={scenes}
          data={data}
        />
      )}
      <Loader loading={loader} backdrop thickness={3} position="absolute" />
    </div>
  );
};
